
import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { useInsufficientBalanceStore } from './insufficient-balance-store'

/**
 * InsufficientBalanceDialog — shown when a generation job fails due to insufficient wallet balance.
 *
 * Uses a Zustand store so any node can trigger it via `showInsufficientBalance()`.
 * Must be mounted once at the canvas page level.
 */
export function InsufficientBalanceDialog() {
  const { open, requiredAmount, currentBalance, hideInsufficientBalance } =
    useInsufficientBalanceStore()

  const balanceNum = currentBalance ? parseFloat(currentBalance) : 0

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) hideInsufficientBalance() }}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon name="alert-triangle" className="h-5 w-5 text-destructive" />
            Insufficient Balance
          </DialogTitle>
          <DialogDescription>
            Your wallet balance is too low to run this job. Contact admin for credits.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 pt-2">
          {currentBalance && (
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Current balance</span>
              <span className="font-mono font-medium text-foreground">${balanceNum.toFixed(2)}</span>
            </div>
          )}
          {requiredAmount && (
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Estimated cost</span>
              <span className="font-mono font-medium text-destructive">${parseFloat(requiredAmount).toFixed(2)}</span>
            </div>
          )}
        </div>

        <div className="flex justify-end pt-4">
          <Button variant="outline" onClick={hideInsufficientBalance}>
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
